"use client";

import * as React from 'react';
import { CircleX } from 'lucide-react';
import { Input } from '@/shared/components/ui/input';
import { cn } from '@/shared/lib/utils';

export interface EInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    clearable?: boolean;
    clearButtonAriaLabel?: string;
    clearButtonClassName?: string;
    clearIconClassName?: string;
    inputClassName?: string;
    onClear?: () => void;
    wrapperClassName?: string;
}

export const EInput = React.forwardRef<HTMLInputElement, EInputProps>(
    function EInput(
        {
            className,
            clearable = false,
            clearButtonAriaLabel = '清空输入',
            clearButtonClassName,
            clearIconClassName,
            inputClassName,
            onClear,
            wrapperClassName,
            ...props
        },
        ref,
    ) {
        return (
            <div className={cn('relative', wrapperClassName)}>
                <Input ref={ref} className={cn(className, inputClassName)} {...props} />

                {clearable ? (
                    <button
                        type="button"
                        onClick={onClear}
                        aria-label={clearButtonAriaLabel}
                        className={cn(
                            'absolute right-2 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full text-[#7C7C7C] transition hover:bg-white/8 hover:text-white',
                            clearButtonClassName,
                        )}
                    >
                        <CircleX className={cn('h-3.5 w-3.5', clearIconClassName)} />
                    </button>
                ) : null}
            </div>
        );
    },
);

EInput.displayName = 'EInput';